import React from "react";
import './App.css';
import { Route, Switch, useHistory } from "react-router-dom";
import ContactsBlack from "./BiolyBlack/ContactsBlack";
import PortfolioBlack from "./BiolyBlack/PortfolioBlack";
import HomeClassic from "./BiolyBlack/HomeClassic";
import MainBiolyBlack from "./BiolyBlack/MainBiolyBlack";
import ServicesBlack from "./BiolyBlack/ServicesBlack";
import MapBlack from "./BiolyBlack/MapBlack";



export default function App() {
    const history = useHistory();
    return (
            <Switch>
            <Route exact path="/">
                <HomeClassic history={history}/>
            </Route>
            <Route exact path="/faq">
                <MainBiolyBlack history={history}/>
            </Route>
            <Route exact path="/terms-conditions">
                <ServicesBlack history={history}/>
            </Route>
            <Route exact path="/privacy-policy">
                <PortfolioBlack history={history}/>
            </Route>
            <Route exact path="/install-modern-appforce">
                <MapBlack history={history}/>
            </Route>
            <Route exact path="/contact-us">
                <ContactsBlack history={history}/>
            </Route>
        </Switch>


    );
}
